<template>
	<div class="app-body fit-body" :class="[{'is-home': isHome}, {'no-sidebar': !showSidebar}, 'bg-gray-gradient']">
		<main-header v-if="!isHome"></main-header>
		<main-nav v-if="showSidebar"></main-nav>
		<main class="container fit-body">
			<router-view></router-view>
			<div class="bottom-room"></div>
		</main>
		<undo/>
	</div>
</template>
<script>
    import MainHeader from "./Components/Navigation/MainHeader";
    import MainNav    from "./Components/Navigation/MainNav";
    import Undo       from "./Components/Undo";
    import DataLoader from "../Data/Source/DataLoader";

    export default {
        components: {
            Undo,
            MainHeader,
            MainNav,
        },
        computed  : {
            showSidebar() {
                return !/(home|login|register|reset-password|404)/.test(this.$route.name);
            },
            isHome() {
                return /(home)/.test(this.$route.name);
            },
        },

        created() {
            new DataLoader().load();
        }
    }
</script>